const GroceryItem = ({
  groceryItem,
  updateQuantity,
  updateMeasurement,
  removeGroceryItem,
  measurements,
}) => {
  console.log("GroceryItem log ", groceryItem);
  const setQuantity = (value) => {
    console.log("GroceryItem updating quantity to ", value);
    updateQuantity(groceryItem, value);
  };

  const setMeasurement = (value) => {
    console.log("GroceryItem updating measurement to ", value);
    updateMeasurement(groceryItem, value);
  };

  return (
    <li>
      <div className="flex flex-wrap items-center gap-2 bg-teal-50 border border-teal-100 rounded-md px-3 py-2">
        <label className="text-sm text-stone-800">
          {groceryItem?.ingredient}
        </label>
        <input
          type="text"
          className="w-14 border border-stone-300 rounded px-2 py-1 text-sm"
          onChange={(e) => setQuantity(e.target.value)}
          value={groceryItem?.quantity}
        ></input>
        {groceryItem?.measurement && (
          <select
            id="dropdown"
            value={groceryItem?.measurement}
            onChange={(e) => setMeasurement(e.target.value)}
            className="border border-stone-300 rounded px-2 py-1 text-sm bg-white"
          >
            <option value="" disabled>
              -- Measurements --
            </option>
            {measurements.map((m) => (
              <option key={m.description} value={m.description}>
                {m.description}
              </option>
            ))}
          </select>
        )}
        <button
          type="button"
          className="ml-auto h-6 w-6 shrink-0 inline-flex items-center justify-center rounded-full bg-white text-stone-500 hover:bg-stone-200 hover:text-stone-700 text-xs font-bold"
          onClick={() => removeGroceryItem(groceryItem)}
        >
          x
        </button>
      </div>
    </li>
  );
};

export default GroceryItem;
